import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import { ICreateNewsfeedPayload, IGetQueryParams } from "../interfaces/Index";

import NewsfeedPage from "../components/pages/Newsfeed/NewsfeedPage";

export const mapStateToProps = (state: any): any => {
  const { zone, newsfeeds } = state;
  return {
    isLoading: newsfeeds.isLoading,
    isError: newsfeeds.isError,
    error: newsfeeds.error,
    pagination: newsfeeds.pagination,
    isNewsfeedAdded: newsfeeds.isNewsfeedAdded,
    isNewsfeedUpdated: newsfeeds.isNewsfeedUpdated,
    isFetchNewsfeedError: newsfeeds.isFetchNewsfeedError,
    isNewsfeedListFetched: newsfeeds.isNewsfeedListFetched,
    newsfeedListFetched: newsfeeds.newsfeedListFetched,
    citiesList: zone.citiesList,
    isCityListFetched: zone.isCityListFetched,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchCities: () => dispatch(actions.fetchCities()),
    getNewsfeedList: (queryPrams?: IGetQueryParams) =>
      dispatch(actions.getNewsfeedListAction(queryPrams)),
    createNewsfeed: (payload: ICreateNewsfeedPayload) =>
      dispatch(actions.createNewsfeedAction(payload)),
    updateNewsfeed: (id: string, payload: ICreateNewsfeedPayload) =>
      dispatch(actions.updateNewsfeedAction(id, payload)),
  };
};

const NewsfeedContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NewsfeedPage);
export default NewsfeedContainer;
